import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Joins class names; later Tailwind classes win over earlier ones (so callers can override). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
